import {
	MODULE_NAME,
	BASE_API,
	SET_INTEGRATIONS,
	INTEGRATIONS,
	SET_INTEGRATION,
	INTEGRATION,
	SET_LOADING,
	LOADING,
	TOAST_MESSAGES_PUSH,
	SAVE_INTEGRATION
} from './integrations-mutation-types';

import { ApiService as api } from '@/services/axiosHelper';
import buildRoute from '@/composables/build-route';

let messageObj = {
	statusCode: 400,
	message: 'An error occurred. Please try again.'
};

export default {
	strict: process.env.NODE_ENV !== 'production',
	name: MODULE_NAME,
	namespaced: true,
	state: {
		[INTEGRATIONS]: {},
		[INTEGRATION]: {},
		[LOADING]: false
	},
	mutations: {
		[SET_INTEGRATIONS](state, obj) {
			state[INTEGRATIONS] = obj;
		},
		[SET_INTEGRATION](state, obj) {
			state[INTEGRATION] = obj;
		},
		[SET_LOADING](state, value) {
			state.loading = value;
		}
	},
	actions: {
		async [SET_INTEGRATIONS]({ dispatch, commit }, params) {
			commit(SET_INTEGRATIONS, {});
			commit(SET_LOADING, true);
			const path = `integrators/${params.integratorId}/${BASE_API}`;
			await api
				.get(buildRoute(path, params))
				.then(res => {
					commit(SET_INTEGRATIONS, res);
				})
				.catch(error => {
					if (error) {
						messageObj.message = error;
					} else {
						messageObj.message = 'Integration can not be found.';
					}
					dispatch(TOAST_MESSAGES_PUSH, messageObj, {
						root: true
					});
				});

			commit(SET_LOADING, false);
		},
		async [SET_INTEGRATION]({ dispatch, commit }, params) {
			commit(SET_INTEGRATION, {});
			commit(SET_LOADING, true);
			const path = `integrators/${params.integratorId}/${BASE_API}/${params.id}`;
			await api
				.get(path)
				.then(res => {
					commit(SET_INTEGRATION, res);
				})
				.catch(error => {
					if (error) {
						messageObj.message = error;
					} else {
						messageObj.message = 'Integration can not be found.';
					}
					dispatch(TOAST_MESSAGES_PUSH, messageObj, {
						root: true
					});
				});

			commit(SET_LOADING, false);
		},
		async [SAVE_INTEGRATION]({ commit }, params) {
			let action = 'added';
			let path = `integrators/${params.integratorId}/${BASE_API}`;

			const parseResponse = () => {
				messageObj = {
					statusCode: 200,
					message: `Integrator successfully ${action}.`
				};
			};
			if (params.id) {
				action = 'edited';
				path += `/${params.id}`;
				await api
					.path(path, params.payload) //TODO? Dev review
					.then(res => {
						console.log(res);
						//commit(SET_INTEGRATION, res);
						parseResponse();
					})
					.catch()
					.finally(() => {
						console.log(messageObj);
					});
			} else {
				await api
					.post(path, params)
					.then(res => {
						commit(SET_INTEGRATION, res);
						parseResponse();
					})
					.catch()
					.finally(() => {
						console.log(messageObj);
					});
			}
		}
	},
	getters: {
		[INTEGRATIONS]: state => state[INTEGRATIONS],
		[INTEGRATION]: state => state[INTEGRATION],
		[LOADING]: state => state[LOADING]
	}
};
